import { useAsync } from "@nxsys/hooks/useAsync";
import { updateAllAEPNApi } from "@nxsys/services/api/aepn";
import { UpdateAllAEPNResponse } from "@nxsys/types/api/aepn";
import { showMessage } from "@nxsys/utils/message";
import { useEffect } from "react";
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useUpdateAllAEPNApi = () => {
  const { value, loading, error, run } = useAsync<
    UpdateAllAEPNResponse,
    void
  >(updateAllAEPNApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};
